// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/fields/Input/index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/fields/Input/index.tsx");
  import.meta.hot.lastModified = "1740183864614.1545";
}
// REMIX HMR END

import { clsx } from "clsx";
import { forwardRef } from "react";
export const Input = forwardRef(_c = ({
  type = "text",
  className,
  ...props
}, ref) => {
  return <input ref={ref} type={type} className={clsx("bg-neutral-50 rounded-lg border border-primary-300 py-4 px-3 text-neutral-600", "disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:text-neutral-300", "focus:border-primary-600 focus:outline-none focus:ring-primary-600 focus:ring-offset-primary-600", "active:border-primary-600 hover:border-primary-600", "placeholder:text-neutral-600 focus:placeholder:opacity-0", "aria-[invalid=true]:border-error-600 aria-[invalid=true]:ring-error-600 aria-[invalid=true]:ring-offset-error-600", className)} autoComplete="new-password" {...props} id={props.name} />;
});
_c2 = Input;
var _c, _c2;
$RefreshReg$(_c, "Input$forwardRef");
$RefreshReg$(_c2, "Input");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;